import type { FeedbackState } from "@productlane/db/browser"
import type { ThreadFilters } from "@productlane/zero/queries"

import type {
	DetailThreadsFilters,
	StatusGroup,
} from "@/components/detail-screen/detail-threads-toolbar"

export const STATUS_GROUP_STATES: Record<StatusGroup, FeedbackState[]> = {
	open: ["NEW", "UNSNOOZED"],
	snoozed: ["SNOOZED"],
	done: ["PROCESSED", "COMPLETED"],
}

const EMPTY_FILTERS: DetailThreadsFilters = {
	statuses: [],
	origins: [],
	assigneeIds: [],
	tagIds: [],
}

export interface DetailThreadScope {
	contactId?: string
	companyId?: string
	projectId?: string
	issueId?: string
	tagId?: string
	assigneeId?: string
	userFilters?: DetailThreadsFilters
}

/**
 * A scope passed in by the screen pins that dimension, so the toolbar can only
 * narrow within it. The member page pins the assignee this way.
 */
export const buildDetailThreadFilters = ({
	contactId,
	companyId,
	projectId,
	issueId,
	tagId,
	assigneeId,
	userFilters = EMPTY_FILTERS,
}: DetailThreadScope): ThreadFilters => {
	const result: ThreadFilters = {}
	if (contactId) {
		result.personIds = [contactId]
	}
	if (companyId) {
		result.companyIds = [companyId]
	}
	if (projectId) {
		result.projectIds = [projectId]
	}
	if (issueId) {
		result.issueIds = [issueId]
	}

	const tagIds = [...(tagId ? [tagId] : []), ...userFilters.tagIds]
	if (tagIds.length > 0) {
		result.tagIds = tagIds
	}
	if (userFilters.statuses.length > 0) {
		result.statuses = userFilters.statuses.flatMap(
			(group) => STATUS_GROUP_STATES[group],
		)
	}
	if (userFilters.origins.length > 0) {
		result.origins = userFilters.origins
	}
	const assigneeIds = assigneeId ? [assigneeId] : userFilters.assigneeIds
	if (assigneeIds.length > 0) {
		result.assigneeIds = assigneeIds
	}
	return result
}
